import * as error from '../internal/encoder/matchers/error';
export { default as traverse } from '../internal/encoder/traverse';
export const matchers = {
    error: {
        encode: error.encode,
        decode: error.decode
    }
};

//# sourceMappingURL=encoder.js.map